import React from 'react';
import PropTypes from 'prop-types';
import 'mdui/components/text-field.js';
import './style.css';

function MDUITextField({
  label,
  name,
  value,
  type = 'text',
  onChange,
  onBlur,
  variant = 'filled',
  placeholder,
  helperText,
  clearable = false,
  icon,
  endIcon,
  readonly = false,
  disabled = false,
  error = false,
  rows = 1,
  minRows,
  maxRows,
  maxlength = 1000,
  className = '',
  style = {},
  children,
  ...rest
}) {
  return (
    <mdui-text-field
      label={label}
      name={name}
      value={value}
      type={type}
      variant={variant}
      placeholder={placeholder}
      clearable={clearable}
      icon={icon}
      end-icon={endIcon}
      readonly={readonly}
      disabled={disabled}
      onInvalid={e => {
        e.preventDefault();
        e.target.setCustomValidity('');
      }}
      rows={rows}
      maxlength={maxlength}
      onInput={onChange}
      onBlur={onBlur}
      helper={helperText}
      class={className}
      style={{
        '--mdui-text-field-border-color': error
          ? 'var(--mdui-color-error)'
          : 'var(--mdui-color-primary)',
        '--mdui-text-field-border-width': '1px',
        ...style
      }}
      {...rest}
    >
      {children}
    </mdui-text-field>
  );
}

MDUITextField.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  type: PropTypes.oneOf(['text', 'password', 'email', 'number']),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  variant: PropTypes.string,
  placeholder: PropTypes.string,
  helperText: PropTypes.string,
  clearable: PropTypes.bool,
  icon: PropTypes.string,
  endIcon: PropTypes.string,
  readonly: PropTypes.bool,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  error: PropTypes.bool,
  rows: PropTypes.number,
  minRows: PropTypes.number,
  maxRows: PropTypes.number,
  maxlength: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node
};

export default MDUITextField;
